import React from 'react';
import { useAuthenticationContext } from '../hooks/useAuthenticationContext';
import { IGuild } from '../models/IGuild';
import styles from './../styles/App.module.scss';
import GuildPicker from '../components/GuildPicker';
import Section from '../components/Design/Section';

interface IDashboardProps { }

interface IDashboardCard
{
    title: string;
    icon: string;
    description: string;
}

const dashboardCards: IDashboardCard[] = [
    { title: "Administrere medlemmer og interessenter", icon: "People", description: "Opret og opdater oplysninger om laugsmedlemmer, investorer og andre tilknyttede personer." },
    { title: "Foretage udbetalinger", icon: "Money", description: "Beregn og registrer udbetalinger til medlemmerne på baggrund af vindmøllernes produktion og økonomi." },
    { title: "Udarbejde servicebreve og anpartskontrol", icon: "Mail", description: "Ved årets afslutning kan du nemt oprette og eksportere de nødvendige dokumenter direkte fra systemet." },
    { title: "Registrere produktionstal", icon: "BarChart4", description: "Indtast løbende produktionen, så oplysningerne er klar til rapporter og udsendelser." }
];

export const Dashboard: React.FunctionComponent<IDashboardProps> = (props: React.PropsWithChildren<IDashboardProps>) => {    
    const [showGuildPicker, setShowGuildPicker] = React.useState<boolean>(false);
    const { user, guild, setCurrentGuild } = useAuthenticationContext();

    React.useEffect(() => {
        if(user != null && user.guilds.length > 1 && guild == null)
        {
          setShowGuildPicker(true);
        } 
      }, []);
      return <div className={styles.contentContainer} style={{textAlign:"center"}}>            
      <div className={styles.heading}><h2>Velkommen, {user?.name} 😎</h2></div>
      <div>Med dette system kan du nemt holde styr på dit vindmøllelaug samlet ét sted. Du kan blandt andet:</div>
      <br/>      
      <div style={{display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(220px, 1fr))", gap:"15px", marginTop:"15px", marginBottom:"20px"}}>
        {dashboardCards.map(card =>
          <Section key={card.title} title={card.title} icon={card.icon}>
            <span style={{fontSize:"13px", color:"#605e5c"}}>{card.description}</span>
          </Section>
        )}
      </div>
      <br/>
      <div>Vi har gjort systemet så enkelt som muligt, så du kan bruge tiden på dit vindmøllelaug frem for administration.
      <br /><br />
      Har du spørgsmål eller brug for hjælp, er du altid velkommen til at <a href="mailto:uhrevind@uhrevind.dk?subject=Kontakt fra Uhrevind">kontakte os</a> 🌬️💼</div>
      {showGuildPicker && <GuildPicker onSelect={(guild: IGuild | undefined) => { setCurrentGuild(guild as IGuild); setShowGuildPicker(false); } } />}
      </div>
}

export default Dashboard;